<div class="privacy-container">
  <div class="privacy-content">
    <h1>Privacy Policy</h1>
    <p>This Privacy Policy describes how MyFleetMan Car Rental Software ("we," "us," or "our") collects, uses, and shares your personal information when you use our service.</p>
    
    <h2>1. Information We Collect</h2>
    <p>We collect information you provide directly to us, such as when you create an account, make a booking, or contact us for support. This may include:</p>
    <ul>
      <li>Name and contact information</li>
      <li>Payment information</li>
      <li>Travel preferences and booking history</li>
      <li>Device and usage information</li>
    </ul>
    
    <h2>2. How We Use Your Information</h2>
    <p>We use the information we collect to:</p>
    <ul>
      <li>Provide and maintain our services</li>
      <li>Process your bookings and payments</li>
      <li>Send you important updates and notifications</li>
      <li>Improve our services and user experience</li>
      <li>Comply with legal obligations</li>
    </ul>
    
    <h2>3. Information Sharing</h2>
    <p>We do not sell, trade, or otherwise transfer your personal information to third parties without your consent, except as described in this policy or as required by law.</p>
    
    <h2>4. Data Security</h2>
    <p>We implement appropriate security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction.</p>
    
    <h2>5. Your Rights</h2>
    <p>You have the right to:</p>
    <ul>
      <li>Access your personal information</li>
      <li>Correct inaccurate information</li>
      <li>Request deletion of your information</li>
      <li>Opt out of marketing communications</li>
    </ul>
    
    <h2>6. Cookies and Tracking</h2>
    <p>We use cookies and similar technologies to enhance your experience and analyze usage patterns. You can control cookie settings through your browser preferences.</p>
    
    <h2>7. Changes to This Policy</h2>
    <p>We may update this Privacy Policy from time to time. We will notify you of any material changes by posting the new policy on this page.</p>
    
    <h2>8. Contact Us</h2>
    <p>If you have any questions about this Privacy Policy, please contact us at privacy&#64;myfleetman.com.</p>
  </div>
</div>